// ----------------------------------------------------------------------------
// Snippet: Menu
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import $ from "jquery";

// Styles
import "./_menu.scss";
import "./_menu--dropdown.scss";

// -------------------------------------
// Hooks
// -------------------------------------

function openMenu(menu, focusItem) {
    closeAllMenus(menu.$dropdown);
    // open menu
    menu.$dropdown.addClass("js--isOpen");
    menu.$dropdown.children(".menu__link").attr("aria-expanded", "true");

    if (typeof focusItem !== "undefined") {
        // move focus
        focusItem.focus();
    }
}

function closeMenu(submenu) {
    // close menu
    submenu.$parentDropdown.removeClass("js--isOpen");
    submenu.$parentDropdown
        .children(".menu__link")
        .attr("aria-expanded", "false");
}

function closeAllMenus(menuDropdown) {
    menuDropdown.removeClass("js--isOpen");
    menuDropdown.siblings().removeClass("js--isOpen");
    menuDropdown.children(".menu__link").attr("aria-expanded", "false");
    menuDropdown
        .siblings()
        .children(".menu__link")
        .attr("aria-expanded", "false");
}

function hoverMenu() {
    if ($(window).width() >= 1025) {
        $(".menu__item--dropdown:not(.js--bound)")
            .addClass("js--bound")
            .on("mouseenter mouseleave", allowHoverOnMenu);
    } else {
        $(".menu__item--dropdown.js--bound")
            .removeClass("js--bound")
            .off("mouseenter mouseleave", allowHoverOnMenu);
    }
}

function allowHoverOnMenu(e) {
    e.preventDefault();
    if (e.type === "mouseenter") {
        $(e.currentTarget).addClass("js--isOpen");
        $(e.currentTarget)
            .children(".menu__link")
            .attr("aria-expanded", "true");
    }
    if (e.type === "mouseleave") {
        $(e.currentTarget).removeClass("js--isOpen");
        $(e.currentTarget)
            .children(".menu__link")
            .attr("aria-expanded", "false");
    }
}

$(function () {
    // Opens dropdowns
    $(".menu__item--dropdown > .dropdown__icon").on("click", function (e) {
        var $dropdown = $(this).closest(".menu__item--dropdown");

        if ($dropdown.siblings().hasClass("js--isOpen")) {
            $dropdown.siblings().removeClass("js--isOpen");
            $dropdown.addClass("js--isOpen");

            $(this).attr("aria-expanded", "true");
        } else {
            $dropdown.toggleClass("js--isOpen");

            if ($dropdown.hasClass("js--isOpen")) {
                $(this).attr("aria-expanded", "true");
            } else {
                $(this).attr("aria-expanded", "false");
            }
        }
    });

    // Opens dropdowns
    $(".menu__item--dropdown > .dropdown__icon").on("keydown", function (e) {
        let keyCode = e.code;

        if (keyCode == "Space" || keyCode == "Enter") {
            e.preventDefault();

            var $dropdown = $(this).closest(".menu__item--dropdown");

            if ($dropdown.siblings().hasClass("js--isOpen")) {
                $dropdown.siblings().removeClass("js--isOpen");
                $dropdown.addClass("js--isOpen");

                $(this).attr("aria-expanded", "true");
            } else {
                $dropdown.toggleClass("js--isOpen");

                if ($dropdown.hasClass("js--isOpen")) {
                    $(this).attr("aria-expanded", "true");
                } else {
                    $(this).attr("aria-expanded", "false");
                }
            }
        }
    });

    hoverMenu();
    // $(window).on('resize', hoverMenu);

    $(
        ".menu--header .menu__item--dropdown .dropdown__link, .menu--header .menu__item--dropdown .dropdown__image-link",
    ).on("focus", function (e) {
        var menu = {
            $menuLink: $(e.target),
            $menuItem: $(e.target).closest(".menu__item"),
            $dropdownList: $(e.target).closest(".dropdown__list"),
            $dropdown: $(e.target).closest(".menu__item--dropdown"),
            $dropdownLink: $(e.target).closest(".dropdown__link"),
        };

        if (!menu.$dropdown.hasClass("js--isOpen")) {
            openMenu(menu);
        }
    });

    $(
        ".dropdown__item .dropdown__link, .dropdown__item .dropdown__image-link",
    ).on("keydown", function (e) {
        var submenu = {
            $menuLink: $(e.target),
            $dropdown: $(e.target).parents(".dropdown__item"),
            $parentDropdown: $(e.target).parents(".menu__item"),
            $parentLink: $(e.target)
                .parents(".menu__item")
                .children(".menu__link"),
        };

        let key = e.key;

        if (key === "Tab") {
            var nextMenuItem = submenu.$dropdown.next(),
                prevMenuItem = submenu.$dropdown.prev();

            if (e.shiftKey) {
                // Shift + Tab
                if (prevMenuItem.length <= 0) {
                    closeMenu(submenu);
                }
            } else {
                // Tab only

                if (nextMenuItem.length <= 0) {
                    closeMenu(submenu);
                }
            }
        }
    });
});
